import React, { useState } from "react";
import { Typography, MenuItem, useTheme, Box } from "@mui/material";

interface SelectionMenuProps {
  handleSelectAll: () => void;
  handleDeselectAll: () => void;
  handleInvertSelection: () => void;
  isAnySelected: boolean;
  isAllSelected: boolean;
  onStatusChange: (message: string | null) => void;
}

const SelectionMenu: React.FC<SelectionMenuProps> = ({
  handleSelectAll,
  handleDeselectAll,
  handleInvertSelection,
  isAnySelected,
  isAllSelected,
  onStatusChange,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const theme = useTheme();

  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
    onStatusChange(null); // Limpa a mensagem ao fechar o menu
  };

  return (
    <Box
      onMouseEnter={() => setIsMenuOpen(true)}
      onMouseLeave={handleMenuClose}
      sx={{
        position: "relative",
        display: "inline-block",
      }}
    >
      {/* Texto "Selecionar" */}
      <Typography
        sx={{
          color: theme.palette.text.primary,
          cursor: "pointer",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        Selecionar
      </Typography>

      {/* Menu dentro da mesma box */}
      {isMenuOpen && (
        <Box
          sx={{
            position: "absolute",
            top: "100%", // Alinha o menu logo abaixo do texto
            left: 0,
            zIndex: 1,
            backgroundColor:
              theme.palette.mode === "dark" ? "#424242" : "#d4eaff",
            color: theme.palette.text.primary,
            borderColor:
              theme.palette.mode === "dark" ? "#616161" : "#b0bec5",
            borderRadius: 1,
            boxShadow: "0px 6px 10px rgba(0,0,0,0.5)",
            minWidth: "150px",
          }}
        >
          {/* Selecionar Todos */}
          <Box
            onMouseEnter={() =>
              isAllSelected &&
              onStatusChange("Todos os itens já estão selecionados.")
            }
            onMouseLeave={() => onStatusChange(null)}
          >
            <MenuItem
              onClick={() => {
                handleSelectAll();
                handleMenuClose();
              }}
              disabled={isAllSelected}
            >
              Selecionar Todos
            </MenuItem>
          </Box>

          {/* Remover Seleção */}
          <Box
            onMouseEnter={() => {
              if (!isAnySelected) onStatusChange("Nenhum item selecionado.");
            }}
            onMouseLeave={() => onStatusChange(null)}
          >
            <MenuItem
              onClick={() => {
                handleDeselectAll();
                handleMenuClose();
              }}
              disabled={!isAnySelected}
            >
              Remover Seleção
            </MenuItem>
          </Box>

          {/* Inverter Seleção */}
          <Box
            onMouseEnter={() =>
              onStatusChange("Inverta a seleção para alternar os itens.")
            }
            onMouseLeave={() => onStatusChange(null)}
          >
            <MenuItem
              onClick={() => {
                handleInvertSelection();
                handleMenuClose();
              }}
            >
              Inverter Seleção
            </MenuItem>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SelectionMenu;
